module.exports = __webpack_public_path__ + "static/media/smile-chat.1c5fa03a.svg";